<script setup lang="ts">
interface Props {
  products: [];
  name: string;
  url: string;
  mobile: boolean;
  limit: number;
}
const { products, name, url, mobile, limit } = defineProps<Props>()

const productsMobile = computed(() => limit ? products.slice(0, limit) : products)

</script>

<template>
  <ClientOnly>
    <div v-if="products.length">
      <div class="text-24 lg:text-30 font-medium py-[25px]">
        {{ name }}
      </div>
      <ul v-if="mobile" class="flex flex-wrap justify-center md:justify-between gap-[10px]">
        <li v-for="p in productsMobile" :key="p.id" class="group w-[calc(50%-5px)] md:w-[calc(25%-10px)] max-w-[262px]">
          <ProductListItem :products="p" class="mb-[30px]" />
        </li>
      </ul>
      <Carousel v-else :options="{ slidesToScroll: 'auto', containScroll: 'keepSnaps', loop: true }" class="relative [--slide-spacing:5px] sm:[--slide-spacing:15px] lg:[--slide-spacing:30px]">
        <Carousel.Slide v-for="product in products" :key="product.id" class="shrink-0 basis-1/2 sm:basis-1/3 md:basis-1/4">
          <ProductListItem :products="product" class="mb-[30px] group max-w-[262px]" />
        </Carousel.Slide>

        <template #addons="{ prev, next }">
          <button class="z-10 text-16 bg-white/60 absolute w-10 h-10 top-1/2 -translate-y-1/2 cursor-pointer rounded flex items-center justify-center left-2" @click.stop="prev">
            <i class="icon-arrow-button -rotate-180" />
          </button>

          <button class="z-10 text-16 bg-white/60 absolute w-10 h-10 top-1/2 -translate-y-1/2 cursor-pointer rounded flex items-center justify-center right-2" @click.stop="next">
            <i class="icon-arrow-button" />
          </button>
        </template>
      </Carousel>
      <NuxtLink :to="url" class="btn btn-secondary btn-lg md:max-w-[336px] mx-auto mb-[50px]">
        <span>Pokaż więcej produktów</span>
        <i class="icon-arrow-button text-[10px] rotate-90" />
      </NuxtLink>
    </div>
  </ClientOnly>
</template>
